import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppSettings } from '../configuration/appsettings';
import { BackEndApiType } from '../configuration/backend-api-type';
import { OidcConfig } from './oidc-config.interface';

@Injectable({
	providedIn: 'root',
})
export class OidcConfigSetupService {
	httpClient: HttpClient;

	constructor(handler: HttpBackend, private appSettings: AppSettings) {
		this.httpClient = new HttpClient(handler);
	}

	public getConfig(): Observable<OidcConfig> {
		if (this.appSettings.settings.b2c.useRemoteConfig && this.appSettings.settings.b2c.useRemoteConfig === true) {
			const baseUrl = this.appSettings.settings.serverSettings[BackEndApiType.B2C].baseUrl;
			return this.httpClient.get<OidcConfig>(`${baseUrl}b2cconfig`);
		} else {
			return of({
				clientId: this.appSettings.settings.b2c.client_id,
				policies: [
					{
						isDefault: true,
						schemeName: this.appSettings.settings.b2c.signinPolicy,
						policyName: this.appSettings.settings.b2c.signinPolicy,
					},
				],
				tenant: this.appSettings.settings.b2c.tenant,
			});
		}
	}
}
